<template>
  <info-dialog-template
    v-model="isShownDialog"
    :title="$t('payout.info.title')"
    @click="handleClose"
  >
    <div :class="$style.container">
      <div :class="$style.text">
        {{ $t('payout.info.description') }}
      </div>

      <div
        v-f-weight="400"
        :class="$style.text"
        v-html="displaySafeDealStatus"
      ></div>

      <!-- TODO: после того, как сделаем параметр "Обрабатывается провайдером" - можно расскоментировать -->
      <!-- <div :class="$style.text">
        {{ $t('payout.safe.deal.balance', { amount: displayBalance }) }}
      </div> -->

      <template v-if="isSafeDeal">
        <!-- TODO: после того, как сделаем параметр "Обрабатывается провайдером" - удалить -->
        <div :class="$style.text">
          {{ $t('payout.safe.deal.balance', { amount: displayBalance }) }}
        </div>

        <div :class="$style.text">
          <router-link v-if="content.unconfirmedCount > 0" :to="{ path: 'cabinet', query: { dealStatus: ['OPENED', 'CHALLENGE_PROCESSING'] }}">
            <p v-color:green>
              {{ $t('payout.safe.deal.unconfirmed.count', { count: displayUnconfirmedCount }) }}
            </p>
          </router-link>
          <p v-else v-color:green>
            {{ $t('payout.safe.deal.unconfirmed.count', { count: displayUnconfirmedCount }) }}
          </p>
          <p>
            {{ $t('payout.safe.deal.unconfirmed.amount', { amount: displayUnconfirmedAmount }) }}
          </p>
        </div>

        <div :class="$style.text">
          <router-link v-if="content.confirmedCount > 0" :to="{ path: 'cabinet', query: { dealStatus: 'CLOSED' }}">
            <p v-color:green>
              {{ $t('payout.safe.deal.confirmed.count', { count: displayConfirmedCount }) }}
            </p>
          </router-link>
          <p v-else v-color:green>
            {{ $t('payout.safe.deal.confirmed.count', { count: displayConfirmedCount }) }}
          </p>
          <p>
            {{ $t('payout.safe.deal.unconfirmed.amount', { amount: displayConfirmedAmount }) }}
          </p>
        </div>

        <div :class="$style.text">
          <!-- TODO: @danealton ожидаем доработок от Азата -->
          <!-- <p>Обрабатывается провайдером: {{ displayCommission }}</p> -->
          <p>
            {{ $t('payout.safe.deal.commission', { amount: displayCommission }) }}
          </p>
          <p>
            {{ $t('payout.safe.deal.available.amount', { amount: displayAvailableAmount }) }}
          </p>
        </div>
      </template>

      <template v-else>
        <div v-if="content.unconfirmedCount > 0" :class="$style.text">
          <router-link :to="{ path: 'cabinet', query: { dealStatus: ['OPENED', 'CHALLENGE_PROCESSING'] }}">
            <p v-color:green>
              {{ $t('payout.safe.deal.unconfirmed.count', { count: displayUnconfirmedCount }) }}
            </p>
          </router-link>
          <p>
            {{ $t('payout.safe.deal.unconfirmed.amount', { amount: displayUnconfirmedAmount }) }}
          </p>
        </div>

        <!-- TODO: после того, как сделаем параметр "Обрабатывается провайдером" - удалить -->
        <div :class="$style.text">
          {{ $t('payout.safe.deal.balance', { amount: displayAcceptedPaymentAmount }) }}
        </div>

        <div :class="$style.text">
          <!-- TODO: @danealton ожидаем доработок от Азата -->
          <!-- <p>Обрабатывается провайдером: {{ displayCommission }}</p> -->
          <p>
            {{ $t('payout.safe.deal.commission', { amount: displayCommission }) }}
          </p>
          <p>
            {{ $t('payout.safe.deal.available.amount', { amount: displayAvailableAmount }) }}
          </p>
        </div>
      </template>
    </div>
  </info-dialog-template>
</template>

<script>
// TODO: @danealton подумать как избавить от этого
import { mapState } from 'vuex';

import { formatAmount } from 'lib/utils/amount';

import InfoDialogTemplate from 'templates/InfoDialogTemplate';

export default {
  name: 'PayoutInfoDialog',
  components: {
    InfoDialogTemplate,
  },
  props: {
    value: Boolean,
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isShownDialog: false,
    };
  },
  computed: {
    currency() {
      return this.PROJECT_INFO.currency;
    },
    isSafeDeal() {
      return this.content.safeDeal;
    },
    displaySafeDealStatus() {
      if (this.isSafeDeal) {
        return this.$t('payout.safe.deal.used', {
          startTag: '<span style="color: var(--color-green);">',
          endTag: '<span>',
        });
      }

      return this.$t('payout.safe.deal.unused', {
        startTag: '<span style="color: var(--color-grey);">',
        endTag: '<span>',
      });
    },
    totalCount() {
      const { confirmedCount, unconfirmedCount } = this.content;

      return Number(confirmedCount) + Number(unconfirmedCount);
    },
    displayUnconfirmedCount() {
      return `${this.content.unconfirmedCount} / ${this.totalCount}`;
    },
    displayConfirmedCount() {
      return `${this.content.confirmedCount} / ${this.totalCount}`;
    },
    // TODO: после того, как сделаем параметр "Обрабатывается провайдером" - удалить
    displayAcceptedPaymentAmount() {
      return formatAmount(this.content.acceptedPaymentAmount, this.currency);
    },
    displayCommission() {
      return formatAmount(this.content.commission, this.currency);
    },
    displayAvailableAmount() {
      return formatAmount(this.content.availableAmount, this.currency);
    },
    displayUnconfirmedAmount() {
      return formatAmount(this.content.unconfirmedAmount, this.currency);
    },
    displayConfirmedAmount() {
      return formatAmount(this.content.confirmedAmount, this.currency);
    },
    displayBalance() {
      return formatAmount(this.content.balance, this.currency);
    },
    ...mapState(['PROJECT_INFO']),
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.isShownDialog = val;
      },
    },
    isShownDialog: {
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    handleClose() {
      this.isShownDialog = false;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +font-type(medium, 14, 20)
    color: var(--color-white)

  .text
    opacity: .75

    &:not(:last-child)
      margin-bottom: 20px
</style>
